import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import LanguageToggle from './LanguageToggle';
import { mockData } from '../mock';

const Header = ({ currentLang, onLanguageChange }) => {
  const location = useLocation();
  const t = mockData.translations[currentLang];

  const navItems = [
    { path: '/', label: t.nav.home },
    { path: '/about', label: t.nav.about },
    { path: '/services', label: t.nav.services },
    { path: '/investor', label: t.nav.investor },
    { path: '/contact', label: t.nav.contact }
  ];

  return (
    <header className="fixed top-0 w-full bg-black border-b border-white/25 z-50">
      <div className="px-[7.6923%] py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img 
              src={mockData.logo.url} 
              alt={mockData.logo.alt}
              className="h-10 w-10"
            />
            <div className="text-2xl font-bold text-white">
              Nusantara <span className="text-[#00FFD1]">Capital.ai</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-lg font-medium transition-colors duration-300 ${
                  location.pathname === item.path
                    ? 'text-[#00FFD1]'
                    : 'text-white/70 hover:text-white'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Language Toggle */}
          <LanguageToggle 
            currentLang={currentLang} 
            onLanguageChange={onLanguageChange} 
          />
        </div>
      </div>
    </header>
  );
};

export default Header;